import { Grid, Paper } from "@material-ui/core";
import React from "react";
import LogActivityTeacherContent from "../../components/TeacherManagement/LogActivityTeacherContent";

export default function LogActivityTeacher() {
    return (
        <Paper className="p-2 p-lg-3">
            <Grid container spacing={0}>
                <Grid item xs={12} className="mb-3">
                    <h4>Logs Activity</h4>
                </Grid>
                <Grid item xs={12}>
                    <LogActivityTeacherContent />
                </Grid>
            </Grid>
        </Paper>
    );
}
